/**
 * @christianjtr
 * Hacky mapping validation...
 * * @param {object} errorData
 * It should be improved with a standardized error message, and an optimised error body schema validation mechanism
 */

const validErrorBodyKeys: {
    [key: string]: {
        validProps: { key: string; typeChecker(value: any): boolean }[];
        errorMessage(errorData: any): string;
    };
} = {
    INTERNAL: {
        validProps: [
            { key: 'error', typeChecker: (value: any): boolean => typeof value === 'string' },
            { key: 'error_description', typeChecker: (value: any): boolean => typeof value === 'string' },
            { key: 'data', typeChecker: (value: any): boolean => Array.isArray(value) },
        ],
        errorMessage: (errorData): string =>
            `[${errorData.error}][${errorData.error_description}]: ${JSON.stringify(errorData.data)}`,
    },
    STUART: {
        validProps: [
            {
                key: 'error',
                typeChecker: (value: any): boolean => typeof value === 'object' && value.reason && value.type,
            },
            { key: 'ok', typeChecker: (value: any): boolean => typeof value === 'boolean' },
        ],
        errorMessage: (errorData): string => `[${errorData.error.type}]: ${errorData.error.reason}`,
    },
};

const parseErrorMessage = (errorData: any): string => {
    let errorMessage = JSON.stringify(errorData);

    Object.keys(validErrorBodyKeys).forEach((prop) => {
        const isValidBodyError: boolean = Object.entries(errorData).every((entry) => {
            const [key, value] = entry;
            const bodyKey = validErrorBodyKeys[prop].validProps.find((bk) => bk.key === key);
            return bodyKey && bodyKey.typeChecker(value);
        });
        if (isValidBodyError) errorMessage = validErrorBodyKeys[prop].errorMessage(errorData);
    });

    return errorMessage;
};

export default parseErrorMessage;
